import { Typography } from '@mui/material';
import {FooterWrapper} from './FooterStyled';
import { Congiguration } from '../../Constants/AppConstants';
import { Content } from './Content';
const Footer=()=>{
    return(
        <FooterWrapper >
        <Typography variant='h5'>{Content.TAG} {Congiguration.Year} {Content.HEADING} Version {Congiguration.Version} Build {Congiguration.Build}.</Typography>
        </FooterWrapper>
    )
}

export default Footer;